import { alpha, createStyles, makeStyles, Theme } from '@material-ui/core';
import commonStyles from 'config/commonStyles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        ...commonStyles,
        ordersPage: {
            display: 'flex',
            height: '100%',
            position: 'absolute',
            left: '50%',
            transform: 'translate(-50%,0)',
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: 200,
            }),
        },
        root: {
            flexGrow: 1,
            marginLeft: 8,
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100%',
            backgroundColor: 'transparent',
            //maxWidth: 784,
        },
        orderDetailsHeader: {
            height: 76,
            backgroundColor: theme.palette.common.white,
            padding: '0 24px',
        },
        orderDetailsHeadingText: {
            fontSize: 10,
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
            color: alpha(theme.palette.common.black, 0.87),
        },
        orderDetailsGroupText: {
            fontSize: 14,
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
            color: alpha(theme.palette.common.black, 0.87),
            fontWeight: 700,
            margin: '10px 0 15px 0',
            display: 'flex',
            alignItems: 'center',
            overflowWrap: 'anywhere',
        },
        orderDetailsHeadingBackground: {
            width: 100,
            height: 20,
            borderRadius: 100,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 14,
            color: theme.palette.common.white,
            paddingBottom: 2,
        },
        orderNumber: {
            fontWeight: 500,
            fontSize: '12px',
            textAlign: 'center',
            width: '100%',
            //lineHeight: '30px',
        },
        orderQrCodeName: {
            fontSize: '13px',
            fontWeight: 700,
            color: theme.palette.common.black,
        },
        orderHeaderItem: {
            padding: '9px 15px ',
            backgroundColor: alpha(theme.palette.secondary.light, 0.3),
            height: 34,
            borderRadius: 7,
            margin: '5px 11px 5px 0',
            alignItems: 'flex-start',
            border: '1px solid transparent',
            cursor: 'pointer',
            '&>div:first-child': {
                marginBottom: 3,
            },
            '&:nth-last-child(-n+2):hover, &:nth-last-child(-n+2):active': {
                border: '1px solid #99567E',
            },
        },
        orderHeaderItemText: {
            '& span:first-child': {
                fontWeight: 'bold',
                fontSize: 16,
                lineHeight: '140.2%',
                marginRight: 5,
            },
        },
        orderHeaderItemActive: {
            border: '1px solid #99567E !important',
            backgroundColor: `${alpha(theme.palette.secondary.light, 0.3)} !important`,
        },
        orderItemsDetailsContainer: {
            ...commonStyles.flexRowSpaceBetween,
            backgroundColor: theme.palette.common.white,
            marginTop: 8,
            flexGrow: 1,
        },
        orderItemsDetails: {
            //width: 441,
            padding: '0 24px 13px 24px',
            height: '98.2%',
            display: 'flex',
            flexDirection: 'column',
            borderRight: `1px solid ${theme.palette.secondary.light}`,
            flexGrow: 1,
            overflow: 'hidden',
        },
        orderItemsDetailsHeader: {
            height: 60,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        orderItemsContainer: {
            display: 'flex',
            overflow: 'auto',
            flexDirection: 'column',
            //justifyContent: 'space-between',
            flexGrow: 1,
            height: 640,
        },
        orderItemsFooter: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            padding: 2,
            marginTop: 10,
        },
        orderItemsFooterCard: {
            ...commonStyles.flexRowSpaceBetween,
            width: 'calc(100% - 28px);',
            padding: '0 14px',
            height: 52,
            marginTop: 16,
            filter: 'drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.11));',
        },
        orderItemsFooterCardPrice: {
            fontSize: 16,
            color: theme.palette.primary.main,
            '& span': {
                fontSize: 22,
                fontWeight: 'bold',
            },
        },
        orderItemCardTitle: {
            fontWeight: '700',
            fontSize: 16,
            lineHeight: '140.2%',
            color: theme.palette.common.black,
        },
        orderItemCardTitleReady: {
            color: theme.palette.common.white,
        },
        orderItemCard: {
            boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.11)',
            padding: '14px 14px 8px 5px',
            marginBottom: 5,
            minHeight: 80,
            flexGrow: 1,
            '& .OrderItemCardDescription': {
                fontSize: 14,
                lineHeight: '150%',
                letterSpacing: '0.25',
            },
            '& .OrderItemCardPrice': {
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
                fontSize: 14,
                color: theme.palette.primary.main,
                minWidth: 90,
                marginLeft: 10,
            },
            '&.Disabled .OrderItemCardTitle, &.Disabled .OrderItemCardDescription, &.Disabled .OrderItemCardPrice, &.Disabled .MuiCheckbox-root':
                {
                    color: `${theme.palette.grey[400]} !important`,
                    pointerEvents: 'none',
                },
        },
        orderItemCardDaily: {
            boxShadow: 'none',
            marginBottom: 0,
            paddingTop: 0,
            paddingBottom: 0,
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            minHeight: 80,
        },
        orderItemCardPrice: {
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            fontSize: 14,
            color: theme.palette.primary.main,
            minWidth: 90,
            marginLeft: 10,
        },
        orderItemCardPriceReady: {
            color: theme.palette.common.white,
        },
        orderItemCardPaid: {
            backgroundColor: theme.palette.success.light,
        },
        orderItemCardReady: {
            backgroundColor: '#0073DE',
            '& .OrderItemCardDescription': {
                color: theme.palette.common.white,
            },
            '& .MuiCheckbox-root:not(.dailyMenuDeliveryCheckbox)': {
                color: `${theme.palette.common.white} !important`,
                '&.Mui-checked': {
                    color: `${theme.palette.common.white} !important`,
                },
                '&.Mui-disabled': {
                    color: `${alpha(theme.palette.common.white, 0.5)} !important`,
                },
            },
        },
        orderItemCardDeliveredOrClosed: {
            backgroundColor: theme.palette.secondary.light,
        },
        dailyMenuDeliveryCheckbox: {
            paddingRight: 0,
            position: 'absolute',
            right: -35,
            zIndex: 10,
        },
        disabledOrderItemAmount: {
            color: `${theme.palette.grey[400]} !important`,
            pointerEvents: 'none',
            cursor: 'unset',
        },
        disabledMenu: {
            color: `${theme.palette.grey[400]} !important`,
            pointerEvents: 'none',
        },
        orderStatus: {
            alignItems: 'center',
            backgroundColor: 'transparent',
            marginRight: 0,
            position: 'relative',
            cursor: 'pointer',
            border: '1px solid transparent',
            '&:hover, &:focus, &:active': {
                backgroundColor: alpha(theme.palette.secondary.light, 0.3),
            },
        },
        selected: {
            border: '1px solid #99567E',
            pointerEvents: 'none',
        },
        customerDataContainer: {
            width: 334,
            minWidth: 334,
            backgroundColor: alpha(theme.palette.secondary.light, 0.3),
            height: '100%',
            overflowY: 'auto',
        },
        customerData: {
            //height: '100%',
            margin: '20px 24px 13px 24px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
        customerDataItem: {
            display: 'flex',
            alignItems: 'flex-start',
            marginTop: 25,
            color: theme.palette.text.primary,
            fontSize: 14,
            lineHeight: '21px',
            '& div': {
                height: 18,
                width: 18,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                marginRight: 16,
            },
        },
        customerNote: {
            color: theme.palette.text.primary,
            fontSize: 14,
            lineHeight: '21px',
            width: '95%',
            overflowWrap: 'break-word',
            marginTop: 25,
            marginBottom: 26,
        },
        categoryFilterContainer: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        categoryFilterItem: {
            fontWeight: 'bold',
            fontSize: 16,
            border: `1px solid ${theme.palette.primary.main}`,
            borderRadius: 100,
            color: theme.palette.primary.main,
            display: 'inline-block',
            padding: '5px 20px',
            textAlign: 'center',
            minWidth: 83,
            cursor: 'pointer',
            margin: '0 12px 18px 0',
            userSelect: 'none',
            '&.selected': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.common.white,
            },
        },
        selectedFilterIcon: {
            '&::after': {
                content: '""',
                height: 7,
                width: 7,
                backgroundColor: theme.palette.primary.main,
                borderRadius: 100,
                position: 'absolute',
                top: 2,
                left: 17,
            },
        },
        checkboxContainer: {
            marginLeft: 15,
            display: 'flex',
            alignItems: 'start',
            justifyContent: 'space-between',
            width: '100%',
            position: 'relative',
        },
        itemPrice: {
            fontSize: 18,
            fontWeight: 'bold',
            marginLeft: 5,
        },
        blueTabContainer: {
            width: '100%',
            '& div': {
                width: 'calc(100% + 48px)',
                margin: '0 -24px 7px -24px;',
            },
        },
        buttonsContainer: {
            display: 'flex',
            '& .MuiButton-root': {
                padding: '6px 25px',
            },
        },
        orderItemAmountContainer: {
            display: 'block',
        },
        orderItemAmount: {
            border: `1px solid ${theme.palette.grey[300]}`,
            borderRadius: 20,
            display: 'flex',
            margin: '10px 0 0 20px',
            justifyContent: 'center',
            padding: '2px 0 4px 0',
            alignItems: 'center',
        },
        orderItemAmountNumber: {
            fontWeight: 900,
            fontSize: 14,
            margin: '0 12px',
            userSelect: 'none',
        },
        orderItemAmountControl: {
            fontWeight: 900,
            fontSize: 17,
            color: theme.palette.grey[300],
            cursor: 'pointer',
            userSelect: 'none',
            '&.Disabled': {
                pointerEvents: 'none',
                cursor: 'unset',
            },
        },
        oderActions: {
            ...commonStyles.flexRowSpaceBetween,
        },
        orderEditButton: {
            cursor: 'pointer',
            '&.Disabled': {
                pointerEvents: 'none',
                cursor: 'unset',
                opacity: 0.5,
            },
            height: 18,
            width: 18,
        },
        removeOrderItem: {
            padding: 9,
            color: theme.palette.primary.main,
            cursor: 'pointer',
            '&.Disabled': {
                pointerEvents: 'none',
                cursor: 'unset',
                opacity: 0.5,
            },
        },
        highlighter: {
            backgroundColor: theme.palette.secondary.main,
        },
        filterDisabled: {
            pointerEvents: 'none',
            cursor: 'unset',
        },
        changeStatusDropdown: {
            zIndex: 2,
            position: 'absolute',
            width: '100%',
            top: '110%',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-around',
            padding: 10,
        },
        dateTime: {
            '&::-webkit-datetime-edit': {
                display: 'none',
            },
            '&::-webkit-calendar-picker-indicator': {
                position: 'absolute',
                cursor: 'pointer',
                top: 0,
                right: 0,
                padding: 0,
                height: 150,
                width: 150,
                background: 'transparent',
            },
        },
        dishAmountAbsolute: {
            position: 'absolute',
            padding: '1px 5px',
            lineHeight: 1,
            right: 0,
            background: 'linear-gradient(180deg, #FFD79A 9.9%, #FF9F9F 100%)',
            boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.05)',
            borderRadius: 5,
            fontWeight: 900,
            fontSize: 16,
            textAlign: 'center',
            color: theme.palette.primary.dark,
            top: 43,
            bottom: 'auto',
            paddingTop: 4,
            height: 20,
        },
        dishAmount: {
            padding: '1px 5px',
            lineHeight: 1,
            background: 'linear-gradient(180deg, #FFD79A 9.9%, #FF9F9F 100%)',
            boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.05)',
            borderRadius: 5,
            fontWeight: 900,
            fontSize: 16,
            textAlign: 'center',
            paddingTop: 4,
            color: theme.palette.primary.dark,
        },
        dishAmountReady: {
            background: theme.palette.common.white,
            color: '#0073DE',
        },
        dishSize: {
            padding: '1px 5px',
            lineHeight: 1,
            right: 32,
            bottom: 7,
            background: '#E7E7E7',
            boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.05)',
            borderRadius: 5,
            fontWeight: 400,
            fontSize: 16,
            textAlign: 'center',
            color: theme.palette.primary.dark,
            paddingTop: 4.5,
            paddingBottom: 4.5,
            paddingRight: 8,
            paddingLeft: 8,
        },
        dishSizeReady: {
            background: theme.palette.common.white,
            color: '#0073DE',
        },
        changeOfIngredientsContainer: {
            borderTop: `1px solid ${theme.palette.secondary.light}`,
            //width: '115%',
            //marginRight: '1%',
            marginRight: -14,
            marginLeft: -4,
            padding: '0 14px',
            marginBottom: 10,
        },
        changeOfIngredientsChipContainer: {
            display: 'flex',
            flexDirection: 'row',
            width: '300px',
            flexWrap: 'wrap',
        },
        changeOfIngredientChip: {
            color: theme.palette.common.white,
            fontSize: '14px',
            fontWeight: '500',
            height: '23px',
            minWidth: '117px',
            width: 'auto',
            borderRadius: '100px',
            padding: '0 10px 0px 10px',
            marginLeft: 10,
            marginTop: 10,
            lineHeight: '23px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
        },
        dishIngredientDialog: {
            paddingLeft: 0,
            paddingRight: 0,
            '& > div': {
                marginLeft: 0,
            },
            overflowY: 'auto',
        },
        servicesDropdown: {
            '& .MuiPaper-root.MuiMenu-paper': {
                width: 'auto',
                maxWidth: 'unset',
            },
            '& .MuiList-root': {
                width: 'unset',
            },
        },
        orderPaymentRoot: {
            width: '100%',
            marginBottom: 25,
            '& .MuiAccordion-root': {
                marginBottom: 5,
                filter: 'none',
            },
            '& .MuiAccordion-root::before': {
                content: '',
            },
            '& .AccordionSummary-expandIcon': {
                transform: 'none',
            },
            '& .MuiAccordionDetails-root': {
                display: 'block',
                padding: 0,
            },
            '& .MuiTypography-body1': {
                fontWeight: 700,
                color: theme.palette.secondary.dark,
            },
            '& .MuiAccordionSummary-content.Mui-expanded': {
                margin: '12px 0',
            },
            '& .MuiSvgIcon-root': {
                color: theme.palette.secondary.main,
            },
            '& .MuiSvgIcon-root:nth-child(2)': {
                color: theme.palette.primary.main,
            },
            '& .MuiIconButton-edgeEnd': {
                marginRight: 0,
            },
        },
        paymentIcon: {
            ...commonStyles.imageContainerCenter,
            width: 45,
            height: 30,
        },
        paymentStatusContainer: {
            borderTop: `1px solid ${theme.palette.secondary.light}`,
            padding: 8,
        },
        paymentStatus: {
            padding: 15,
            borderRadius: 5,
            backgroundColor: 'rgba(212, 83, 54, 0.16)',
            color: theme.palette.error.light,
            fontWeight: 600,
        },
        paymentStatusPaid: {
            backgroundColor: 'rgba(95, 207, 85, 0.16)',
            color: 'rgba(95, 207, 85, 1)',
            ...commonStyles.flexRowSpaceBetween,
        },
        /* paidText: {
            fontStyle: 'Italic',
            marginLeft: 3,
            fontSize: 14,
        }, */
        paidText: {
            color: theme.palette.success.main,
            fontSize: 14,
            textAlign: 'end',
        },

        amount: {
            fontSize: 20,
            fontWeight: 700,
            color: theme.palette.primary.main,
            marginTop: 5,
        },
        responsibleUserSelector: {
            textAlign: 'start',
            '& .MuiSelect-root.MuiSelect-select.MuiSelect-selectMenu': {
                paddingTop: 20,
                paddingBottom: 15,
            },
        },
        commentSection: {
            paddingLeft: 10,
            '& .MuiInputLabel-shrink': { transform: 'translate(0, 1.5px)' },
            '& .MuiInputBase-input': {
                color: theme.palette.grey[800],
                fontSize: 14,
            },
        },
        textLight: {
            color: theme.palette.common.white,
        },
        stornoModalItemsList: {
            padding: '8px 0',
            flexDirection: 'column',
            alignItems: 'flex-start',
            borderBottom: `1px solid ${theme.palette.grey[200]}`,
        },
        stornoModalMenuDishesTitle: {
            marginLeft: 16,
            marginBottom: 8,
            fontWeight: 'bold',
            color: '#666',
        },
        preOrderTagsContainer: {
            display: 'flex',
            gap: 6,
            marginTop: 6,
            marginBottom: 6,
            flexWrap: 'wrap' as const,
        },
        preOrderTag: {
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.common.white,
            borderRadius: 4,
            padding: '2px 6px',
            fontSize: 11,
            fontWeight: 700,
            lineHeight: '16px',
        },
        pickupSlotTag: {
            backgroundColor: theme.palette.warning.main,
            color: theme.palette.primary.dark,
            borderRadius: 4,
            padding: '2px 6px',
            fontSize: 11,
            fontWeight: 700,
            lineHeight: '16px',
        },
        pickupSlotTagFuture: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.common.white,
        },
    })
);
